import { parse } from "date-fns";

export default function parseDate(s: string, baseDate = new Date(), withTime = false): Date {
  return withTime ? parse(s, "yyyy-MM-dd HH:mm", baseDate) : parse(s, "yyyy-MM-dd", baseDate);
}
